export default __webpack_public_path__ + "static/media/employeeDirectory.6f5daf6a.PNG";